import { render, staticRenderFns } from "./CreateStep2.vue?vue&type=template&id=1b841d2c&scoped=true"
import script from "./CreateStep2.vue?vue&type=script&lang=js"
export * from "./CreateStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b841d2c",
  null
  
)

export default component.exports